import LazyLoad from 'vanilla-lazyload'
import Swiper from 'swiper'
import tippy from 'tippy.js'

import './charts'

window.lazyLoad = new LazyLoad({
    elements_selector: '[data-src], [data-srcset], [data-bg]'
})


document.querySelectorAll('.tooltip').forEach(el => {
    tippy(el, {
        content: el.querySelector('.tooltip-content').innerHTML,
        allowHTML: true,
    })
})


function toggleOnClick(clickSelector, targetSelector, toggleClass) {
    document.querySelectorAll(clickSelector).forEach(el => {
        el.addEventListener('click', (e) => {
            if (targetSelector == null) {
                el.classList.toggle(toggleClass)
            } else {
                var sel = targetSelector //yes it needs a separate variable
                if (el.dataset.key) sel += `[data-key="${el.dataset.key}"]`
                el.closest(sel).classList.toggle(toggleClass)
            }
        })
    })
}


document.querySelectorAll('.callout__media.has-play').forEach(el => {
    el.addEventListener('click', function (e) {
        e.preventDefault()
        var vid = el.querySelector('video')
        if (vid.paused) {
            vid.play()
            vid.controls = true
            el.classList.add('playing')
        } else {
            vid.pause()
            vid.controls = false
            el.classList.remove('playing')
        }
    })
})


document.querySelectorAll('.swiper').forEach(el => {
    if (el.querySelectorAll('.swiper-slide').length > 1) {
        var s = new Swiper(el, {
            loop: true
        })
        window.setInterval(function () { s.slideNext(1000, true) }, 5000)
    }
})


document.querySelectorAll('.fundsection .accordion__item:first-child').forEach(el => {
    el.classList.add('is-active')
})


document.querySelectorAll('.subnav__list [data-key]').forEach(el => {
    el.addEventListener('click', function (e) {
        e.preventDefault()
        var key = el.dataset.key
        //first de-select stuff
        document.querySelector('.subnav__list').querySelectorAll('.subnav__item').forEach(b => { b.classList.remove('is-active') })
        document.querySelectorAll('.fundsection').forEach(t => { t.classList.remove('is-active') })

        //now select clicked
        el.parentElement.classList.add('is-active')
        document.querySelector(`.fundsection[data-key="${key}"]`).classList.add('is-active')
    })
})


document.querySelector('.js-togglemobilenav').addEventListener('click', function (e) {
    e.target.classList.toggle('is-active')
    document.querySelector('.js-mobilenav').classList.toggle('is-active')
    document.documentElement.classList.toggle('is-scroll-lock')
})


document.querySelectorAll('.disclaimer button.accept').forEach(el => {
    el.addEventListener('click', function () {
        var id = el.closest('.disclaimer').dataset.id
        var existing = getCookie('disclaimers')
        var pieces = existing.split('|').filter(p => p)
        if (pieces.filter(p => p == id).length == 0)
            pieces.push(id)
        setCookie('disclaimers', pieces.join('|'), 90)
        location.reload()
    })
})


toggleOnClick('.mobilenav__menu-link', '.has-dropdown', 'is-active')
toggleOnClick('.accordion__head', '.accordion__item', 'is-active')
toggleOnClick('.history__head', '.history__item', 'is-active')


function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return '';
}


function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


window.loadMap = function () {
    document.querySelectorAll('.contacts__map').forEach(function (el) {
        var map = new google.maps.Map(el, {
            zoom: 10,
            maxZoom: 18,
            minZoom: 5,
            center: new google.maps.LatLng(offices[0].MapLat, offices[0].MapLon),
            panControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            gestureHandling: 'greedy',
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            fullscreenControl: false
        })
        var infowindow = new google.maps.InfoWindow();

        var bounds = new google.maps.LatLngBounds()
        offices.forEach(o => {
            var marker = new google.maps.Marker({
                icon: "/public/img/redpin.png",
                position: new google.maps.LatLng(o.MapLat, o.MapLon),
                map: map,
                office: o
            })
            marker.setMap(map)
            bounds.extend(marker.position)
            google.maps.event.addListener(marker, 'click', (function (marker, o) {
                return function () {
                    var ct = `<div><span style="font-weight:bold">${o.Name}</span><br><br>${o.Address}<br>${o.MainPhone}<br>${o.MainEmail}</div>`
                    infowindow.setContent(ct);
                    infowindow.open(map, marker);
                }
            })(marker, o));
        })
        map.fitBounds(bounds)
    })

    document.querySelectorAll('.contacts__location_map').forEach(function (el) {
        var point = new google.maps.LatLng(el.dataset.lat, el.dataset.lon)
        var map = new google.maps.Map(el, {
            zoom: 17,
            maxZoom: 18,
            minZoom: 5,
            center: point,
            panControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            gestureHandling: 'greedy',
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            fullscreenControl: false
        })
        var marker = new google.maps.Marker({
            icon: "/public/img/redpin.png",
            position: point,
            map: map,
        })
        marker.setMap(map)
    })
}